import {useContext, useState, useEffect} from 'react'
import {GlobalContext} from '../context/GlobalState'
import { Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { Link, useHistory } from 'react-router-dom'


const EditUser = (props) => {
   const [selectedUser, setSelectedUser] = useState({
      id: '',
      name: ''
   })
   const {users, editUser} = useContext(GlobalContext) 
   const history = useHistory()
   const currentUserId = props.match.params.id //allows u acceess this id from the url

   useEffect(() => {
      const userId = currentUserId;//one on the url
      const selectedUser = users.find(user => user.id === userId) //users from the GlobalContext
      setSelectedUser(selectedUser)
   }, [currentUserId, users])  //[] means that if the currentUserId or the users is changing, the useEffect is running

   const onSubmit = (user) => {
      editUser(selectedUser) //selectedUser becomes the new updated user
      history.push('/')
   }

   const handleChange = (e) => {
      setSelectedUser({...selectedUser, [e.target.name]: e.target.value}) // name="name" below was imp bcos of e.target.name
   }

    return (
       <Form onSubmit={onSubmit}>
         <FormGroup>
            <Label>Name</Label>
            <Input type="text" name="name" value={selectedUser.name} onChange={handleChange} placeholder="Enter Name.." style={{marginBottom: '.5rem'}}></Input>
         </FormGroup>
         
            
        <Button type="submit">Edit Name</Button>
        <Link to="/" className="btn btn-danger ml-2" style={{marginLeft: '.5rem'}}>Cancel</Link>
       </Form>
    )
}

export default EditUser
